export default __webpack_public_path__ + "static/media/telegram.67e7236e.svg";